import type { ComponentType } from 'react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { GitLabProjectPickerField } from './GitLabProjectPickerField';

// Type assertion avoids referencing @rjsf/utils from scaffolder-react (TS2742)
export const GitLabProjectPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GitLabProjectPicker',
    component: GitLabProjectPickerField,
  }),
) as unknown as ComponentType;
